interface DevAutofillButtonProps {
  onClick: () => void;
  label?: string;
}

export function DevAutofillButton({ onClick, label = "Dev: Autofill" }: DevAutofillButtonProps) {
  if (!import.meta.env.DEV) return null;
  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full rounded-lg border border-dashed border-yellow-500 bg-yellow-50 px-3 py-2 text-sm font-medium text-yellow-800 hover:bg-yellow-100"
    >
      {label}
    </button>
  );
}

export default DevAutofillButton;
